import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'Is 3 years old too young to start?',
  answer: 'Not at all! Our Mini Troopers curriculum is specifically designed for the developmental stage of 3 to 5-year-olds. We focus on gross motor skills and basic listening.'
}, {
  question: 'Do parents participate in the class?',
  answer: 'Parents watch from our comfortable viewing area. This helps children learn independence and how to take instruction directly from our coaches.'
}, {
  question: 'What should my child wear for the trial?',
  answer: 'Comfortable play clothes or athletic wear (like sweatpants and a t-shirt) are perfect for the first week.'
}];
export function MiniTroopersFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2532" />;
}